import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/parent-guide'

export const getStaticProps = Page.getStaticProps

export default withAuthUser<Page.ParentGuidePageProps>()(Page.ParentGuide)
